export  const PM25 = {
    good: 10,  // <
    fair: 20, // 10 <
    moderate: 25, // 10 <
    poor: 50, // 25 <
    veryPoor: 75, // 50 <
    extreamePoor: 800 // 75 <
}
export  const PM10 = {
    good: 20,  // <
    fair: 40, // 20 <
    moderate: 50, // 40 <
    poor: 100, // 50 <
    veryPoor: 150, // 100 <
    extreamePoor: 1200 // 150 <
}
export  const NO2 = {
    good: 40,  // <
    fair: 90, // 40 <
    moderate: 120, // 90 <
    poor: 230, // 120 <
    veryPoor: 340, // 230 <
    extreamePoor: 1000 // 340 <
}

export  const O3 = {
    good: 50,  // <
    fair: 100, // 50 <
    moderate: 130, // 100 <
    poor: 240, // 130 <
    veryPoor: 380, // 240 <
    extreamePoor: 800 // 380 <
}

export  const SO2 = {
    good: 100,  // <
    fair: 200, // 100 <
    moderate: 350, // 200 <
    poor: 500, // 350 <
    veryPoor: 750, // 500 <
    extreamePoor: 1250 // 750 <
}

export const AQIHEX = {
    good: '#50f0e6',
    fair: '#50ccaa',
    moderate: '#f0e641',
    poor: '#ff5050',
    veryPoor: '#960032', 
    extreamePoor: '#7d2181'
}